import { Tag } from '@okapi/dom-utils';
/**
 * Пытается добавить к текущему пути адрес CDN
 * @param {string} curr
 * @param {string} cdnUrl
 */
export function addCdnURLToResource(curr, cdnUrl) {
    if (curr && cdnUrl && !(curr.startsWith('http://') || curr.startsWith('https://'))) {
        return cdnUrl + curr;
    }
    return curr;
}
/**
 * Переводит адреса бандлов в формат Tag
 * @param resources
 * @param cdnUrl
 */
export function convertStringsToResources(resources, cdnUrl) {
    return {
        scripts: resources.scripts.map(curr => {
            curr = addCdnURLToResource(curr, cdnUrl);
            return new Tag('script', { src: curr });
        }),
        styles: resources.styles.map(curr => {
            curr = addCdnURLToResource(curr, cdnUrl);
            return new Tag('link', { rel: 'stylesheet', href: curr });
        }),
    };
}
export function parseRawBundleConfig(rawBundle) {
    var _a, _b, _c, _d;
    let bundle = {
        ...rawBundle,
        scripts: (_a = rawBundle.scripts) === null || _a === void 0 ? void 0 : _a.map(Tag.fromJson),
        styles: (_b = rawBundle.styles) === null || _b === void 0 ? void 0 : _b.map(Tag.fromJson),
        resources: {},
    };
    if (rawBundle.resources) {
        bundle.resources = {};
        for (const key of Object.keys(rawBundle.resources)) {
            bundle.resources[key] = {
                scripts: (_c = rawBundle.resources[key].scripts) === null || _c === void 0 ? void 0 : _c.map(Tag.fromJson),
                styles: (_d = rawBundle.resources[key].styles) === null || _d === void 0 ? void 0 : _d.map(Tag.fromJson),
            };
        }
    }
    return bundle;
}
